import { render } from "./DefaultLessonPage.vue?vue&type=template&id=2f8d3a03&scoped=true"
import script from "./DefaultLessonPage.vue?vue&type=script&lang=js"
export * from "./DefaultLessonPage.vue?vue&type=script&lang=js"

import "./DefaultLessonPage.vue?vue&type=style&index=0&id=2f8d3a03&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8d3a03"]])

export default __exports__